export const LASERCUT = {
  navbarLogo: "navbar-logo",
  navbarCta: "navbar-cta-consult",
  navLink: (slug) => `nav-link-${slug}`,
  navMobileToggle: "navbar-mobile-toggle",
  heroCtaConsult: "hero-cta-consult",
  heroCtaCatalog: "hero-cta-catalog",
  marqueeText: "marquee-text",
  manifestoChapter: (n) => `manifesto-chapter-${n}`,
  processStep: (n) => `process-step-${n}`,
  catalogCard: (slug) => `catalog-card-${slug}`,
  catalogCtaButton: (slug) => `catalog-cta-${slug}`,
  portfolioFilter: (slug) => `portfolio-filter-${slug}`,
  portfolioCard: (id) => `portfolio-card-${id}`,
  formSection: "custom-request-form",
  formName: "form-name-input",
  formWhatsapp: "form-whatsapp-input",
  formCategory: "form-category-select",
  formSize: "form-size-input",
  formBudget: "form-budget-select",
  formDescription: "form-description-textarea",
  formSubmit: "form-submit-button",
  formSuccess: "form-success-message",
  contactWhatsapp: "contact-whatsapp-button",
  contactEmail: "contact-email",
  contactAddress: "contact-address",
  footerSocial: (name) => `footer-social-${name}`,
};
